import React, { useEffect, useState } from "react";
import "../../../styles/careers/header.scss";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { clientSettingsConfig } from "../../../redux/slices/careersSlices.reducer";
import "../../../i18n/i18n";
import { useTranslation } from "react-i18next";
import Loader from "../../../component/loader/Loader";
import { clientIds, customMenuIds } from "../../../config/clients/clients";
import CustomHeader from "./CareersCustomMenu";
import useClientConfig from "../../../config/careers/clientConfig";


let count = 0;

const CompletionHeader = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const cliendId = useParams();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    const cliendConfig = useSelector((state: any) => state.careers.cliendConfig);
    const resetActiveTap = useSelector(
        (state: any) => state.careers.resetActiveTap
    );
    const loader = useSelector((state: any) => {
        return state?.careers?.loading;
    });
    const activeClient = useSelector((state: any) => {
        return state?.careers?.activeClient;
    });

    const [currentTap, setCurrentTap] = useState<string | number>(0);
    const [currentTapSubMenu, setCurrentTapSubMenu] = useState<boolean>(false);
    const [toggleStyle, setToggleStyle] = useState<string>("");
    const [logoUpdate, setLogoUpdata] = useState("");
    const [checkActivite, setCheckActivite] = useState(false);
    const {clientSiteSettings} = useClientConfig();
    const [isLoading, setIsLoading] = useState(false);

    const templateName = clientSiteSettings?.templateName;
    // const [showLink, setShowLink] = useState(false);

    const [bannerCount, setBannerCount] = useState(0);

    useEffect(() => {
        let interval: any;
        let total_number_of_banners = clientSiteSettings?.bannerData?.length > 0 ? clientSiteSettings?.bannerData?.length : 0;
        //Implementing the setInterval method
        if(bannerCount <= total_number_of_banners-1 ) {
            interval = setInterval(() => {
                setBannerCount((bannerCount) => bannerCount + 1);
            }, 5000);
        } else {
            clearInterval(interval);
            setBannerCount(0);
        }
        
        //Clearing the interval
        return () => clearInterval(interval);
    }, [bannerCount]);

    useEffect(() => {
        if (activeClient?.length > 0) {
            document.body.className = "";
            document.body.classList.add(activeClient[0]["className"]);
            if(location.pathname === "/job-alerts") {
                document.body.classList.add("job-alerts");
            }            
        }
    }, [activeClient]);

    useEffect(() => {
        dispatch<any>(clientSettingsConfig());
    }, []);

    
      useEffect(() => {
         //set custom colors in :root (mandatory for only custom career theme)
        const colors = clientSiteSettings?.customCareerThemeColors || null;
        if(colors){
            const root : any = document.documentElement;
            Object.entries(colors).forEach(([key, value]) => {
                root?.style.setProperty(`--${key}`, `${value}`);
            });
        }
      }, [clientSiteSettings?.customCareerThemeColors]);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (cliendConfig.status === 200) {
            const dataress = cliendConfig?.data?.data?.clientSettings;
            
            sessionStorage.setItem("pr-color", dataress?.brandColor);
            document.title = `${cliendConfig?.data?.data?.clientSettings?.titleTabText}`;
            document.documentElement.style.setProperty(
                "--completion-primary-color",
                dataress?.brandColor
            );
            document.documentElement.style.setProperty(
                "--primary-color",
                dataress?.brandColor
            );
            document.documentElement.style.setProperty(
                "--completion-secondary-color",
                dataress?.secondaryColor
            );
            document.documentElement.style.setProperty(
                "--theam-secondary-color",
                dataress?.secondaryColor
            );
            // document.title = `${candidateData?.clientDetails?.titleTabText} - Compliance`;
            let link: any = document.querySelector("link[rel~='icon']");
            if (!link) {
                link = document.createElement("link");
                link.rel = "icon";
                document.getElementsByTagName("head")[0].appendChild(link);
            }
            link.href = cliendConfig?.data?.data?.clientSettings?.favIcon;
           

            if(location.pathname.includes("/apply-job/")) {
                document.body.classList.add("apply-job-page");
            }else if(location.pathname.includes("/view/")) {
                document.body.classList.add("view-job-page");
            } else if(location.pathname === "/") {
                document.body.classList.add("career-page");
            }

            const lang = cliendConfig?.data?.data?.clientSettings?.language || "en";
            i18n.changeLanguage(lang);
            const clientBodyClass = clientSiteSettings?.clientBodyClass;

            if(clientSiteSettings?.optionFourClient || clientSiteSettings?.customClientOption) {

                const clientCssFiles = clientSiteSettings?.clientCssFiles;
                const clientFontFiles = clientSiteSettings?.clientFontFiles;
                const customClientFolderName = clientSiteSettings?.customClientFolderName;
                let folderName = "";
                if(customClientFolderName){
                    folderName = customClientFolderName;
                }
                else{ 
                    folderName = templateName;
                }

                if(clientCssFiles?.length > 0){
                    clientCssFiles.forEach((cssFiles: any) => {
                        setIsLoading(true);
                        import(`../header/clientsMenu/${folderName}/css/${cssFiles}`).then(() => {
                            setIsLoading(false);
                        });
                    });                                       
                }

                if(clientFontFiles?.length > 0){
                    clientFontFiles.map(function(fontFiles: any) {
                        return import(`../header/clientsMenu/${folderName}/fonts/${fontFiles}`).then(() => {
                            setIsLoading(false);
                        });
                    });
                }
                
            }

            if(clientBodyClass?.length > 0){
                clientBodyClass.map((bodyClass: any) => {
                    return document.body.classList.add(bodyClass);
                });
            }

            if (dataress?.clientCssFilename !== "" && dataress?.clientCssFilename !== null) {
                import(`../../../styles/clientCssFiles/${dataress?.clientCssFilename}`);
            }
        

        }
    }, [cliendConfig]);

    useEffect(() => {
        if (activeClient?.length > 0) {
            document.body.classList.add(activeClient?.[0]?.["className"]);
        }
        if (activeClient?.length > 0) {
            if(templateName === "template_8"){
                document.body.classList.add("default-option-new-theme-micro"); 
            }

            if(templateName === "template_7"){
                document.body.classList.add("default-option-new-theme-custom-font"); 
            }

            if(templateName === "template_9"){
                document.body.classList.add("default-theme-template-new-page-id-5");  
                document.body.classList.add("default-theme-template-new-page-id-2");
            }

            if(templateName === "template_10"){
                document.body.classList.add("default-theme-template-new-page-id-1");
            }
        }
    }, [activeClient]);
    useEffect(() => {
        if (location.pathname !== "/") {
            // console.log(cliendId);
            const addHeaderHight: any = document.getElementById("careers-body");
            // addHeaderHight.style.top = "106px";
            // addHeaderHight.classList.add("careers-view");
            // addHeaderHight.classList.add("careers-view");
            // const conpletionViewHeader: any = document.getElementById("careers-header");
            // conpletionViewHeader.classList.add("careers-view-header");
        } else {
            const addHeaderHight: any = document.getElementById("careers-body");
            // addHeaderHight.style.top = "106px";
            addHeaderHight.classList.remove("careers-view");
            document.body.classList.remove("job-alerts");
        }
    }, [location]);

    // console.log(clients?.filter((ress) => ress?.clientId === cliendId.userId));

    const getCurrentMenu = (params: number | string) => {
        // setCurrentTap(0);
        // if (currentTapSubMenu) {
        //     console.log(currentTapSubMenu);
        //     setCurrentTap(params);
        // setCurrentTapSubMenu(false);
        // } else {
        // console.log(currentTapSubMenu);
        if (!checkActivite) {
            setCurrentTap((prs) => {
                if (prs === params || params === 0) {
                    setLogoUpdata("");
                } else {
                    setLogoUpdata("0");
                }
                return prs === params ? 0 : params;
            });
        }

        // }
        // setCurrentTapSubMenu(false);
    };
    // useEffect(() => {
    //     if (resetActiveTap) {
    //         setCurrentTap(0);
    //     }
    //     console.log(resetActiveTap);
    // }, [resetActiveTap]);
    useEffect(() => {
        if (toggleStyle === "") {
            setCurrentTap(0);
            setLogoUpdata("");
        }
    }, [toggleStyle]);

    useEffect(() => {
        // console.log(currentTapSubMenu);
        if (currentTapSubMenu) {
            setCurrentTap(2);
            setLogoUpdata("0");
            count++;
            // setCurrentTap(prs)
        } else {
            if (count !== 0) {
                setCurrentTap(2);
                setLogoUpdata("0");
            }
        }
    }, [currentTapSubMenu]);

    // useEffect(() => {
    //     if(location.pathname === `/careers/job-list/${cliendId?.userId}` || 
    //        location.pathname === `/careers/job-list/${cliendId?.userId}/view/${cliendId?.id}` ||
    //        location.pathname === `/careers/job-list/${cliendId?.userId}/view/${cliendId?.id}/apply-job/register/from/direct` ){
    //         setShowLink(false);
    //     } else if(cliendId?.from !== 'direct'){
    //         setShowLink(!false);
    //     }
    // }, [location.pathname]);

    //Resolves if the current client has a custom menu using the inbuilt clientids
    const hasCustomMenu = (id:any) => {
        return clientSiteSettings?.showHeader || false;
    };

    useEffect(() => {
        const clientScripts = cliendConfig?.data?.data?.clientSettings?.clientScripts;
    
        if (clientScripts) {
            const headerScript = JSON.parse(clientScripts?.headerScript);
            const bodyScript = JSON.parse(clientScripts?.bodyScript);

            // Helper function to create and append a script
            const injectScript = (id: string, content: string, target: HTMLElement, tagType: any) => {
                if (!document.getElementById(id)) {
                    const scriptElement = document.createElement(tagType);
                    scriptElement.type = "text/javascript";
                    scriptElement.id = id;

                    // Use textContent instead of innerHTML for better safety
                    scriptElement.textContent = content;

                    target.appendChild(scriptElement);
                }
            };

            const injectNoScript = (id: string, content: string, target: HTMLElement, tagType: string, scriptAttribute: any) => {
                if (!document.getElementById(id)) {
                    const noscriptElement = document.createElement(tagType);
                    noscriptElement.id = id;

                    const iframeElement = document.createElement("iframe");
                    iframeElement.style.display = "none";
                    iframeElement.width = scriptAttribute?.width || "0px";
                    iframeElement.height = scriptAttribute?.height || "0px";

                    // Create a blob URL for the iframe content
                    const blob = new Blob([content], { type: "text/html" });
                    const blobURL = URL.createObjectURL(blob);

                    iframeElement.src = scriptAttribute?.src || blobURL;

                    noscriptElement.appendChild(iframeElement);
                    target.appendChild(noscriptElement);
                }
            };

            // Helper function to create and append a body script
            if(bodyScript?.length > 0) {
                bodyScript.forEach((scriptData: any, index: any) => {
                    if(scriptData?.type === "raw"){
                        injectScript("body-script-"+index, scriptData.content, document.body, scriptData?.tagtype);
                    }else if(scriptData?.type === "iframe"){
                        injectNoScript("body-script-"+index, scriptData.content, document.body, scriptData?.tagtype, scriptData?.attributes);
                    }
                    
                });
            }

            if(headerScript?.length > 0) {
                headerScript.forEach((headScriptData: any, index: any) => {
                    if(headScriptData?.tagtype === "script"){
                        injectScript("header-script-"+index, headScriptData.content, document.head, headScriptData?.tagtype);
                    }else if(headScriptData?.type === "iframe"){
                        injectNoScript("header-script-"+index, headScriptData.content, document.head, headScriptData?.tagtype, headScriptData?.attributes);
                    }
                });
            }

       

        }
    }, [cliendConfig]);
    

    return (
        <>
            <div>
                <Loader loading={isLoading} />
            </div>
            <div
                onClick={() => { getCurrentMenu(0); }}
                id={"careers-header"}
                className={`bg-dark 
                    ${currentTap === 1 || currentTap === 2 || currentTap === 3
                        ? "active"
                        : " "
                    } 
                    ${location.pathname !== "/"
                        ? "careers-view-header"
                        : ""
                    }
                    ${(location.pathname.indexOf("/apply-job/") !== -1)
                        ? "careers-apply-header"
                        : ""
                    }
                    `}
            ></div>
            {/* dev tech debt :needs a switch case based template implementation */}            
            { hasCustomMenu(cliendConfig?.data?.data?.clientSettings?.clientId) && 
                <CustomHeader clientId={cliendConfig?.data?.data?.clientSettings?.clientId} clientSiteSettings={clientSiteSettings} />
            }

            
            {
                (clientSiteSettings?.banner === "micro_banner") ?
                    <> 
                    <div className="default-option-new-theme-banner micro_banner">                        
                        <div className="page-title-content">
                            <div className="animate-text">
                                <div className="slider-items">
                                    {
                                        clientSiteSettings?.bannerData?.map((banner: any, index: number) => {
                                            return (
                                                <div key={index} className={`slide-item ${bannerCount === index ? "active" : ""}`} data-count={`slide-${index}`}>
                                                    <img src={cliendConfig?.data?.data?.clientSettings?.assetsLink + "/" + banner?.imgUrl} alt={cliendConfig?.assetsLink + "/" + banner?.imgUrl}/>
                                                </div>
                                            );
                                        } )
                                    }                                                                  
                                </div>
                            </div>                           
                        </div>
                    </div>
                </>: ""
            }

        </>
    );
};

export default CompletionHeader;
